<!--
 * @Author: your name
 * @Date: 2022-01-07 10:54:47
 * @LastEditTime: 2022-01-07 14:30:03
-->
<template>
	<el-dialog
		class="online-dialog"
		:close-on-click-modal="false"
		:title="'建站方式选择'" append-to-body
		:visible.sync="dialogVisible"
		width="660px">
		<div class="prepare">
			<p style="font-size:14px;text-align:left;">
				独立建站（PC+MC）: 可根据PC端和移动端用户提供针对性网站方案，独立优化不同关键词。
				<br>
				响应式建站（PC+MC）: 无需分开2次单独建站，节省人工，数据同步更新，同样可优化关键词。
			</p>
			<div class="prepare-btn">
				<el-button @click="$emit('responseFn')" type="warning" round>
					响应式建站
					<i class="recommend">荐</i>
				</el-button>
				<el-button @click="$emit('closeCurModal',tblType)" round>
					独立分开建站
				</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
    export default {
        name: 'SiteTypeDialog',
        data() {
            return {}
        },
		props: ['showDialog','tblType'],
        methods: {},
        watch: {},
        created() {
        },
        mounted() {
        },
        destroyed() {
        },
        computed: {
			dialogVisible: {
				get: function () {
					return this.showDialog
				},
				set: function (val) {
					this.$emit('update:showDialog', val)
				}
			},
		},
    }
</script>

<style scoped lang="scss">
	.prepare {
		width: 100%;
		min-height: 175px;

		p {
			min-height: 52px;
		}

		.prepare-btn {
			padding: 40px 0;
			text-align: center;

			button {
				margin: 0 30px;
				position: relative;
			}
		}
	}
	.recommend{
		position: absolute; top: -9px; right: -1px; width: 34px; height: 18px; font-size: 12px; text-align: center; border-radius: 0 9px 0 9px; color: #fff; background: #f1592a; line-height: 18px;
	}
</style>
